var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_60768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.3333V6.66666C13.3333 4.30964 13.3333 3.13113 12.6011 2.3989C11.8689 1.66666 10.6904 1.66666 8.33333 1.66666H7.5C5.14298 1.66666 3.96447 1.66666 3.23223 2.3989C2.5 3.13113 2.5 4.30964 2.5 6.66666V18.3333",
    stroke: "#3F3F46",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91666 8.33334L6.66666 10.4167H9.16666L7.91666 12.5",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333H1.66666",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.33334L17.2776 4.15539C17.3924 4.24728 17.4499 4.29322 17.5021 4.34004C17.9948 4.78172 18.2923 5.40072 18.3294 6.06137C18.3333 6.13141 18.3333 6.20495 18.3333 6.35204V15.4167C18.3333 16.107 17.7737 16.6667 17.0833 16.6667C16.393 16.6667 15.8333 16.107 15.8333 15.4167V15.3571C15.8333 14.6997 15.3003 14.1667 14.6429 14.1667H13.3333",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.66666H17.0833C16.393 6.66666 15.8333 7.22631 15.8333 7.91666V9.93238C15.8333 10.4704 16.1776 10.9481 16.6881 11.1182L18.3333 11.6667",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_60768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelEfficiency);
export default __webpack_public_path__ + "static/media/Fuel Efficiency.874df5bdaaeb7280edbf37ea897d546b.svg";
export { ForwardRef as ReactComponent };